import { useEffect, useState } from 'react';
export const useStateValue = (value) => {
    const [stateValue, setStateValue] = useState(value);
    useEffect(() => {
        setStateValue(value);
    }, [value]);
    const resetStateValue = () => setStateValue(value);
    return [stateValue, setStateValue, resetStateValue];
};
